/**
 * Condition Registry Models
 * Defines predefined conditions that end users can select from dropdowns
 * instead of writing raw expression strings.
 */

export type ConditionCategory =
  | 'section_visibility'
  | 'permissions'
  | 'data_availability'
  | 'project_settings'
  | 'text_fields'
  | 'impact_method';

export type ConditionValueType =
  | 'boolean'       // truthy check (e.g., showHideSection.isIntroduction)
  | 'comparison'    // ==, !=, >, < (e.g., projectDetails.recycledCreditId == 1)
  | 'array_length'; // .length > 0 (e.g., common.scenarioNameList.length > 0)

/**
 * A single predefined condition option in the registry
 */
export interface ConditionDefinition {
  id: string;
  category: ConditionCategory;
  label: string;
  description?: string;
  expression: string;
  valueType: ConditionValueType;
  comparisonOptions?: {
    operator: '==' | '!=' | '>' | '<' | '>=' | '<=';
    values: { label: string; value: any }[];
  };
}

/**
 * Category metadata for grouping conditions in the UI
 */
export interface ConditionCategoryInfo {
  id: ConditionCategory;
  label: string;
  icon: string;
}

/**
 * Full registry of available conditions
 */
export interface ConditionRegistry {
  categories: ConditionCategoryInfo[];
  conditions: ConditionDefinition[];
}
